const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20portrait%20of%20a%20young%20woman%20with%20soft%20smile%2C%20clean%20warm%20lighting%2C%20minimal%20cream%20background%2C%20avatar%20style%2C%20gentle%20expression&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    name: '漫迷小星',
    time: '2小时前',
    content: '酷漫屋的下拉式阅读体验真的太舒服了！以前看条漫要一直点翻页按钮，现在只需要滑动就能一直往下看，追《剑与远方》一口气看了30话完全停不下来。',
    likes: 128,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20portrait%20of%20a%20young%20man%20with%20cool%20expression%2C%20clean%20warm%20lighting%2C%20minimal%20cream%20background%2C%20avatar%20style&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    name: '二次元猎人',
    time: '5小时前',
    content: '国漫专区做得太用心了，《修灵纪》画风和剧情都很在线。而且最重要的是全免费！再也不用到处找资源了，这里日漫韩漫国漫都有，推荐给了好多朋友。',
    likes: 96,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20portrait%20of%20a%20young%20woman%20with%20cute%20expression%2C%20clean%20warm%20lighting%2C%20minimal%20cream%20background%2C%20avatar%20style%2C%20cheerful&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    name: '甜饼爱好者',
    time: '8小时前',
    content: '恋爱漫画专区是我的快乐源泉！《心跳的频率》画风甜到炸，竖屏阅读感觉就像在翻手机聊天记录一样自然，每天通勤路上必看，希望更新再快一点！',
    likes: 203,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20portrait%20of%20a%20young%20man%20with%20serious%20expression%2C%20clean%20warm%20lighting%2C%20minimal%20cream%20background%2C%20avatar%20style&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
    name: '深夜追更人',
    time: '12小时前',
    content: '用了好几个月了，真心觉得酷漫屋的更新速度是所有平台里最快的。每天凌晨刷新都能看到新内容，《暗影追踪》每次更新我都第一时间追，悬疑剧情太抓人了。',
    likes: 77,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%2C%20clean%20warm%20lighting%2C%20minimal%20cream%20background%2C%20avatar%20style%2C%20friendly&width=80&height=80&seq=comment-avatar-05&orientation=squarish',
    name: '漫画收藏家',
    time: '1天前',
    content: '从朋友推荐过来的，没想到页面做得这么清爽！没有乱七八糟的广告弹窗，阅读体验非常沉浸。主题索引功能也很好用，帮我发现了好几部宝藏冷门漫画。',
    likes: 156,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            读者评论
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            来看看酷漫屋的读者们怎么说，真实用户反馈最靠谱
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((c) => (
            <div
              key={c.name}
              className="bg-background-100 rounded-lg p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-950 truncate">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
                <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
                  <i className="ri-thumb-up-line text-xs"></i>
                  <span className="text-xs">{c.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{c.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}